import React, { Component } from 'react';
import { convertLocalDate } from '../Common/cleanDates';

export const RMADateFormatter = React.createClass({
    render() {
      return (this.props.value) ?
        <span>{convertLocalDate(this.props.value, 'MMM DD YYYY')}</span> : null
    },
});
  

  export default RMADateFormatter;


// WEBPACK FOOTER //
// ./master/jsx/components/RMA/rmaDateFormatter.jsx